import { BRAND_RESOURCES } from '@/constants/brand-resources';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';

import SettingLayout from '../setting-layout';
import { IndentityInfoTypes } from '../../hooks/use-indentity';

import style from './index.less';

const img = BRAND_RESOURCES.unverifiedIdentityImage;
const { Content } = SettingLayout;

const NeedIndentity = (props: { info: IndentityInfoTypes }) => {
  const { status, certify_failed_reason } = props.info;
  const history = useHistory();
  const toAuth = () => {
    history.push(`/auth/idenity`);
  };
  let title = '未实名认证';
  let text = '为配合国家网络安全管理，切实履行监督义务，该功能需要企业完成实名认证后才能使用';

  if (status === 'certifying') {
    title = '实名认证审核中';
    text = '你已经提交实名认证，预计 2 个工作日内完成审核';
  } else if (status === 'failed') {
    title = '实名认证不通过';
    text = `实名认证未通过，原因：${certify_failed_reason}`;
  }

  return (
    <SettingLayout style={{ height: '100%' }}>
      <Content style={{ justifyContent: 'center' }} maxWidth="100%">
        <div className={style.center_content}>
          <img src={img} alt="" />
          <div className={style.title}>{title}</div>
          <div className={style.h2}>{text}</div>
          {status !== 'certifying' ? (
            <Button size="large" onClick={toAuth} type="primary">
              立即认证
            </Button>
          ) : null}
        </div>
      </Content>
    </SettingLayout>
  );
};

export default NeedIndentity;
